import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const currentDate = new Date().toLocaleDateString('en-IN', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <header className="w-full">
      <div className="bg-[#0b5cff] text-white py-3">
        <div className="container mx-auto px-4 flex items-center justify-between">

          {/* Left: Logo */}
          <div className="flex-shrink-0">
            <Link to="/">
              <img
                src="/news.png"
                alt="Pratyaksha News"
                className="h-12 md:h-16 w-auto bg-yellow-300 p-1"
              />
            </Link>
          </div>

          {/* Center: Date and Title */}
          <div className="flex flex-col items-center justify-center flex-grow text-center">
            
            <h1 className="text-2xl md:text-3xl font-bold font-sans">
              Pratyaksha News Epaper
            </h1>
          </div>

          {/* Right: Language Toggle & Admin Links */}
          <div className="flex-shrink-0 flex items-center space-x-4">
            <span className="text-sm font-medium tracking-wide mb-1">
              {currentDate}
            </span>
          </div>

        </div>
      </div>
    </header>
  );
}

export default Header;
